module.exports = __webpack_public_path__ + "img/bg-recipe_sp.b3063ac1.jpg";